import { render, staticRenderFns } from "./cModalDescription.vue?vue&type=template&id=7040b20c"
import script from "./cModalDescription.vue?vue&type=script&lang=js"
export * from "./cModalDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports